import type { MessageRef } from '@elara/domain/models/schemas/shortlist-schemas';

import { createContext } from 'react';

/**
 * Context for providing message reference to widgets
 */
export interface MessageContextValue {
  messageRef?: MessageRef;
  isGenerating?: boolean;
}

export const MessageContext = createContext<MessageContextValue>({});
